import { Fragment } from 'react';
import { useHits } from 'react-instantsearch';

import { ProductCard } from '@/components/atomic/molecules';

const ProductListOrganism = ({ searchPage }) => {
  const { items } = useHits();

  return (
    <Fragment>
      <div
        className='relative grid grid-cols-1 xs:auto-rows-fr xs:grid-cols-2 lg:grid-cols-3 justify-between gap-y-5 md:gap-y-6
        xs:gap-x-4 md:gap-x-6 px-5 md:px-0 pb-0 md:pb-0 mt-1 md:my-5px'
      >
        {items.map((hit) => {
          // eslint-disable-next-line no-underscore-dangle
          const product = hit._source || hit;
          return (
            <ProductCard
              key={product.productNumber || hit.objectID}
              product={product}
              searchPage={searchPage}
            />
          );
        })}
      </div>
    </Fragment>
  );
};

export default ProductListOrganism;
